// @flow

import { Component } from '../jsti/core';
import EventNames from '../constants/EventNames';
import Notifications from '../constants/Notifications';

export default class ViewPanelToggle extends Component {
  #id: string;
  #clickHandler: function;

  /**
   * Initialize the component
   *
   * @param pEl
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);

    const id = this.el.dataset.id;
    if (!id) {
      throw new Error('The identifier is required to trigger a view panel');
    }

    this.#id = this.el.dataset.id;

    this.#clickHandler = this.trigger.bind(this);
    this.el.addEventListener(EventNames.CLICK, this.#clickHandler);
  }

  /**
   * Notify the panel so it can react
   */
  trigger(e: Event): void {
    e.preventDefault();
    this.notify(Notifications.TOGGLE_VIEW_PANEL, { id: this.#id });
  }

  /**
   * Remove all event listeners
   */
  destroy(): void {
    this.el.removeEventListener(EventNames.CLICK, this.#clickHandler);
    super.destroy();
  }
}
